interface DolyamiPaymentDetailsProps {
	totalPrice: string | null;
}

export const DolyamiPaymentDetails = ({
	totalPrice,
}: DolyamiPaymentDetailsProps) => {
	return (
		<>
			<p className="pt-2">
				Всего <span className="font-semibold text-gray-1">{totalPrice}</span>
			</p>
			<p className="pb-6 pt-8 text-gray-3">
				Первый платеж спишем с карты сегодня, следующие — с интервалом в две
				недели. Это не является кредитным обязательством перед банком или
				рассрочкой.
			</p>
		</>
	);
};
